import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignsWelcomeHandoff } from '@/pages/workspaces/automations/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/campaigns/welcome/create` URL, which existing create links use. Flag off the
 * embedded app serves it; flag on it forwards to the migrated URL, query carried.
 */
function JourneysCampaignsWelcomeCreateRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysCampaignsWelcomeHandoff page="create" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/campaigns/welcome/create')({
  component: JourneysCampaignsWelcomeCreateRoute,
});
